import { TokenBalance } from "./token-management/TokenBalance";
import { TransactionHistory } from "./token-management/TransactionHistory";
import { CurrentPlan } from "./token-management/CurrentPlan";
import { TokenPurchase } from "./TokenPurchase";
import { CreditCard } from "lucide-react";

export const TokenManagement = () => {
  return (
    <div className="space-y-8">
      <TokenBalance />
      <CurrentPlan />
      
      <div>
        <h2 className="text-2xl font-bold mb-6 flex items-center gap-2">
          <CreditCard className="h-6 w-6" />
          Purchase Additional Tokens
        </h2>
        <TokenPurchase />
      </div>

      <TransactionHistory />
    </div>
  );
};